import React from 'react';

const DataProtectionLink = () => {
  const openDataProtection = () => {
    // Abrir el documento de protección de datos en una nueva ventana/pestaña
    window.open('/legal/data-protection.html', '_blank');
  };
  
  return (
    <span 
      className="text-[#e31837] underline ml-1 cursor-pointer" 
      onClick={openDataProtection}
    >
      tratamiento de datos personales
    </span>
  );
};

export default DataProtectionLink;